import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9d1f10c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timeline-workout" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "workout-user-date" }
const _hoisted_4 = { class: "workout-user" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "no-map"
}
const _hoisted_8 = { class: "img" }
const _hoisted_9 = { class: "data" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-clock-o",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "data" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-road",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "data elevation"
}
const _hoisted_15 = ["alt"]
const _hoisted_16 = { class: "data-values" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("/ ")
const _hoisted_18 = {
  key: 1,
  class: "data altitude"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-location-arrow",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_20 = { class: "data-values" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" +")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("/- ")

import { Locale, format, formatDistance } from 'date-fns'
  import { ComputedRef, computed, toRefs, withDefaults } from 'vue'

  import StaticMap from '@/components/Common/StaticMap.vue'
  import UserPicture from '@/components/User/UserPicture.vue'
  import { ROOT_STORE } from '@/store/constants'
  import { ISport } from '@/types/sports'
  import { IUserProfile } from '@/types/user'
  import { IWorkout } from '@/types/workouts'
  import { useStore } from '@/use/useStore'
  import { getDateWithTZ } from '@/utils/dates'

  interface Props {
    user: IUserProfile
    useImperialUnits: boolean
    workout?: IWorkout
    sport?: ISport
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    user: null,
    useImperialUnits: { type: Boolean },
    workout: { default: () => ({} as IWorkout) },
    sport: { default: () => ({} as ISport) }
  },
  setup(__props: any) {

const props = __props as { user: IUserProfile, useImperialUnits: boolean, workout: IWorkout, sport: ISport }

  

  const store = useStore()

  const { user, workout, sport, useImperialUnits } = toRefs(props)
  const locale: ComputedRef<Locale> = computed(
    () => store.getters[ROOT_STORE.GETTERS.LOCALE]
  )

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SportImage = _resolveComponent("SportImage")!
  const _component_Distance = _resolveComponent("Distance")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(UserPicture, { user: _unref(user) }, null, 8, ["user"]),
          (_unref(user).username)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                class: "workout-user-name",
                to: {
              name: 'User',
              params: { username: _unref(user).username },
            }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(user).username), 1)
                ]),
                _: 1
              }, 8, ["to"]))
            : _createCommentVNode("", true)
        ]),
        (_unref(workout).id)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: "workout-title",
              to: {
            name: 'Workout',
            params: { workoutId: _unref(workout).id },
          }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(workout).title), 1)
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        (_unref(workout).workout_date && _unref(user))
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "workout-date",
              title: 
            _unref(format)(
              _unref(getDateWithTZ)(_unref(workout).workout_date, _unref(user).timezone),
              'dd/MM/yyyy HH:mm'
            )
          
            }, _toDisplayString(_unref(formatDistance)(new Date(_unref(workout).workout_date), new Date(), {
              addSuffix: true,
              locale: _unref(locale),
            })), 9, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["workout-map", { 'no-cursor': !_unref(workout) }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _unref(workout).id
            ? _ctx.$router.push({
                name: 'Workout',
                params: { workoutId: _unref(workout).id },
              })
            : null
        ))
      }, [
        (_unref(workout))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_unref(workout).with_gpx)
                ? (_openBlock(), _createBlock(StaticMap, {
                    key: 0,
                    workout: _unref(workout)
                  }, null, 8, ["workout"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('workouts.NO_MAP')), 1))
            ]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["workout-data", { 'without-gpx': _unref(workout) && !_unref(workout).with_gpx }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (
          _unref(workout).id
            ? _ctx.$router.push({
                name: 'Workout',
                params: { workoutId: _unref(workout).id },
              })
            : null
        ))
      }, [
        _createElementVNode("div", _hoisted_8, [
          (_unref(sport).label)
            ? (_openBlock(), _createBlock(_component_SportImage, {
                key: 0,
                "sport-label": _unref(sport).label,
                color: _unref(sport).color
              }, null, 8, ["sport-label", "color"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          (_unref(workout))
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_unref(workout).moving), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          (_unref(workout).id)
            ? (_openBlock(), _createBlock(_component_Distance, {
                key: 0,
                distance: _unref(workout).distance,
                digits: 3,
                unitFrom: "km",
                useImperialUnits: _unref(useImperialUnits)
              }, null, 8, ["distance", "useImperialUnits"]))
            : _createCommentVNode("", true)
        ]),
        (_unref(workout) && _unref(workout).with_gpx)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("img", {
                class: "mountains",
                src: "/img/workouts/mountains.svg",
                alt: _ctx.$t('workouts.ELEVATION')
              }, null, 8, _hoisted_15),
              _createElementVNode("div", _hoisted_16, [
                (_unref(workout).id)
                  ? (_openBlock(), _createBlock(_component_Distance, {
                      key: 0,
                      distance: _unref(workout).min_alt,
                      unitFrom: "m",
                      displayUnit: false,
                      useImperialUnits: _unref(useImperialUnits)
                    }, null, 8, ["distance", "useImperialUnits"]))
                  : _createCommentVNode("", true),
                _hoisted_17,
                (_unref(workout).id)
                  ? (_openBlock(), _createBlock(_component_Distance, {
                      key: 1,
                      distance: _unref(workout).max_alt,
                      unitFrom: "m",
                      useImperialUnits: _unref(useImperialUnits)
                    }, null, 8, ["distance", "useImperialUnits"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(workout) && _unref(workout).with_gpx)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                (_unref(workout).id)
                  ? (_openBlock(), _createBlock(_component_Distance, {
                      key: 0,
                      distance: _unref(workout).ascent,
                      unitFrom: "m",
                      displayUnit: false,
                      useImperialUnits: _unref(useImperialUnits)
                    }, null, 8, ["distance", "useImperialUnits"]))
                  : _createCommentVNode("", true),
                _hoisted_22,
                (_unref(workout).id)
                  ? (_openBlock(), _createBlock(_component_Distance, {
                      key: 1,
                      distance: _unref(workout).descent,
                      unitFrom: "m",
                      useImperialUnits: _unref(useImperialUnits)
                    }, null, 8, ["distance", "useImperialUnits"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}
}

})